import { Badge, Icon } from '@deity/falcon-ui';
import type React from 'react';
import { ContentStatus } from 'services/graphql/generated/schemas';

type StatusBadgeProps = {
  status?: ContentStatus;
};
export const StatusBadge: React.FC<StatusBadgeProps> = ({ status = ContentStatus.Draft }) => {
  const statusMap = {
    new: {
      label: 'NEW',
      icon: 'lockOpen',
      color: '#ffffff',
      background: '#e07a7f'
    },
    draft: {
      label: 'DRAFT',
      icon: 'lock',
      color: '#33260b',
      background: '#f7d677'
    },
    published: {
      icon: 'doneAll',
      color: 'white',
      background: '#7581ef'
    },
    deployed: {
      icon: 'cloudDone',
      color: 'white',
      background: '#76b885'
    }
  };
  const { icon, color, background, label } = statusMap[status.toLowerCase()];

  return (
    <Badge style={{ color, background }}>
      {icon && <Icon src={icon} stroke="transparent" style={{ height: '20px', marginRight: '5px' }} />}
      {label ?? status.toUpperCase()}
    </Badge>
  );
};
